import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from "@/components/auth/Login";
import Password from "@/components/auth/Password";
import Otp from "@/components/auth/Otp";
import forget from "@/components/auth/Forget";
import NewPassword from "@/components/auth/NewPassword";
import CheckLogin from "@/components/auth/CheckLogin";
import Error404View from '../views/Error404View.vue'
import Error503View from '../views/Error503View.vue'
import Error403View from '../views/Error403View.vue'

/*import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import axios from 'axios'*/


const routes = [
    {
        path: '/',
        name: 'HomeView',
        component: HomeView,
        meta: {
            requiresAuth: true,
            title: 'ffff',withoutLayout: false
        },
    },

    {
        path: '/admin',
        meta: {requiresAuth: true , permission:'PREFERENCES',withoutLayout: false},
        children: [
            {
                path: 'users/users',
                name: 'UsersComponent',
                meta: {requiresAuth: true,permission:'PREFERENCES', title: 'لیست کاربران'},

                component: () => import('../components/admin/Users')
            },
            {
                path: 'users/users-portal',
                name: 'UsersPortal',
                meta: {
                    requiresAuth: true,
                    title: 'کاربران پرتال',permission: 'PREFERENCES',
                    requiredFeatures: ['portal']
                },

                component: () => import('../components/admin/UsersPortal')
            },
            {
                path: 'users/users-role',
                name: 'UsersRole',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'نقش کاربران',},

                component: () => import('../components/admin/UsersRole')
            },
            {
                path: 'users/bans',
                name: 'Bans',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'مسدودیت ها'},

                component: () => import('../components/admin/BansView')
            },
            {
                path: 'formManage',
                name: 'SettingComponent',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'تنظیمات'},

                component: () => import('../components/admin/Setting')
            },
            {
                path: 'api',
                name: 'ApisComponent',
                meta: {
                    requiresAuth: true,
                    requiredFeatures: ['artificial_intelligence'],
                    title: 'api ها',
                    permission: 'PREFERENCES',
                },

                component: () => import('../components/admin/Apis')
            },
            {
                path: 'api-connections',
                name: 'ApiConnections',
                meta: {
                    requiresAuth: true,
                    requiredFeatures: ['artificial_intelligence'],
                    title: 'اتصال api ها',
                    permission: 'PREFERENCES',
                },

                component: () => import('../components/admin/ApiConnections')
            },
            {
                path: 'log-system',
                name: 'LogsSystem',
                meta: {requiresAuth: true,
                    permission: 'PREFERENCES', title: 'لاگ های سیستم'},
                component: () => import('../components/admin/SystemLogs')
            },

            {
                path: 'financial',
                name: 'FinancialComponent',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: ' فهرست پرداخت ها '},

                component: () => import('../components/admin/Financial')
            },
            {
                path: 'work-flow',
                name: 'WorkFlow',
                meta: {
                    requiresAuth: true,
                    requiredFeatures: ['workflow_management'],
                    permission: 'PREFERENCES', title: 'گردش کارها'
                },

                component: () => import('../components/admin/workflow/WorkFlow.vue')
            },
            {
                path: 'work-flow/diagram/:id?',
                name: 'DiagramComponent',
                meta: {requiresAuth: true,permission: 'PREFERENCES',},

                component: () => import('../components/admin/workflow/Diagram.vue')
            },
            {
                path: 'licences',
                name: 'Licences',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'لایسنس ها'},

                component: () => import( '../components/admin/Licences')
            },
            {
                path: 'bills/:id?',
                name: 'BillsComponent',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'پرداخت ها'},

                component: () => import( '../components/admin/Bills')
            },
            {
                path: 'call-center',
                name: 'CallCenter',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'مرکز تماس'},

                component: () => import( '../components/admin/CallCenter')
            },
            {
                path: 'queues',
                name: 'Queues',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'مدیریت صف ها'},

                component: () => import( '../components/admin/Queues')
            },
            /*{
                path: 'zones',
                name: 'zonesManagement',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'مدیریت مناطق'},

                component: () => import( '../components/admin/zonesManagement/ZonesManagement')
            },*/
            {
                path: 'logs/telegram',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'لاگ های تلگرام'},
                name: 'TelegramLogs',
                component: () => import('../components/management/logs/TelegramLogs')
            },
            {
                path: 'logs/whatsapp',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'لاگ های واتس آپ'},
                name: 'WhatsappLogs',
                component: () => import('../components/management/logs/WhatsappLogs')
            },
            {
                path: 'logs/instagram',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'لاگ های اینستاگرام'},
                name: 'InstagramLogs',
                component: () => import('../components/management/logs/InstagramLogs')
            },
            {
                path: 'logs/bale',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'لاگ های بله'},
                name: 'BaleLogs',
                component: () => import('../components/management/logs/BaleLogs')
            },

            {
                path: 'chat/hi',
                meta: {requiresAuth: true, title: 'صفحه چت'},
                name: 'ChatHi',
                component: () => import('../components/admin/ChatHi')
            },


        ]
    },

    {
        path: '/management',
        meta: {requiresAuth: true,withoutLayout: false},
        children: [
            {
                path: 'dashboard',
                meta: {requiresAuth: true},
                name: 'DashboardManagement',
                component: () => import('../components/management/Dashboard'),

            },
            {
                path: 'profile-setting',
                name: 'ProfileSetting',
                meta: {requiresAuth: true},

                component: () => import('../components/admin/ProfileSetting')
            },
            {
                path: 'user-logs',
                name: 'UserLogs',
                meta: {requiresAuth: true},
                component: () => import('../components/management/UserLogs.vue')
            },
            {
                path: 'request-status',
                name: 'RequestStatus',
                meta: {requiresAuth: true, permission:'TASK_STATUS_LIST'},

                component: () => import( '../components/management/RequestStatus')
            },
            {
                path: 'request-types',
                name: 'RequestType',
                meta: {requiresAuth: true, permission:'TASK_TYPE_LIST'},

                component: () => import( '../components/admin/RequestTypes')
            },
            {
                path: 'tags',
                name: 'TagsComponent',
                meta: {requiresAuth: true, permission:'TAG_LIST'},

                component: () => import( '../components/admin/Tags')
            },
            {
                path: 'faq',
                name: 'FaqComponent',
                meta: {requiresAuth: true, permission:'FAQ_LIST'},
                component: () => import( '../components/admin/Faq')
            },
            {
                path: 'faq-category',
                name: 'FaqCatComponent',
                meta: {requiresAuth: true, permission:'FAQ_CATEGORY_LIST'},
                component: () => import( '../components/admin/FaqCat')
            },
            {
                path: 'departments',
                name: 'DepartmentsComponent',
                meta: {requiresAuth: true, permission:'DEPARTMENT_LIST'},
                component: () => import( '../components/management/Departments')
            },
            {
                path: 'contracts',
                name: 'ContractsComponent',
                meta: {requiresAuth: true, permission:'DEPARTMENT_LIST'},
                component: () => import( '../components/management/ContractComponent')
            },
            {
                path: 'tasks/:id?',
                meta: {requiresAuth: true , permission:'TASK_LIST'},
                name: 'TasksComponent',
                component: () => import('../components/management/TasksComponent')
            },
            {
                path: 'new-request/:id?',
                meta: {requiresAuth: true},
                name: 'NewRequestView',
                component: () => import('../views/management/NewRequestView')
            },
            {
                path: 'edit-request',
                meta: {requiresAuth: true},
                name: 'EditRequestView',
                component: () => import('../views/management/EditRequestView')
            },
            {
                path: 'shifts',
                meta: {requiresAuth: true, permission:'SHIFT_LIST'},
                name: 'ShiftManagement',
                component: () => import('../components/management/ShiftManagement')
            },
            {
                path: 'shifts/assignment',
                meta: {requiresAuth: true, permission:'SHIFT_ASSIGN_USER'},
                name: 'ShiftAssignment',
                component: () => import('../components/management/ShiftAssignment')
            },
            {
                path: 'shifts/live-monitoring',
                meta: {requiresAuth: true, permission:'SHIFT_LIST'},
                name: 'LiveMonitoring',
                component: () => import('../components/management/LiveMonitoring')
            },
            {
                path: 'drafts/qarecords',
                meta: {requiresAuth: true,permission:'VOICE_MAIL_LIST'},
                name: 'qa_records',
                component: () => import('../components/management/drafts/qarecords')
            },
            {
                path: 'drafts/portal',
                meta: {requiresAuth: true,permission:'VOICE_MAIL_LIST', requiredFeatures: ['workflow_management']},
                name: 'portal_c',
                component: () => import('../components/management/drafts/portal')
            },
            {
                path: 'drafts/telegram',
                meta: {requiresAuth: true,permission:'VOICE_MAIL_LIST'},
                name: 'telegram_c',
                component: () => import('../components/management/drafts/telegram')
            },
            {
                path: 'drafts/whatsapp',
                meta: {requiresAuth: true,permission:'VOICE_MAIL_LIST'},
                name: 'whatsapp_c',
                component: () => import('../components/management/drafts/whatsapp')
            },
            {
                path: 'drafts/instagram',
                meta: {requiresAuth: true,permission:'VOICE_MAIL_LIST'},
                name: 'instagram_c',
                component: () => import('../components/management/drafts/instagram')
            },
            {
                path: 'drafts/bale',
                meta: {requiresAuth: true,permission:'VOICE_MAIL_LIST'},
                name: 'bale_c',
                component: () => import('../components/management/drafts/bale')
            },
            {
                path: 'drafts/sms',
                name: 'sms_c',
                meta: {requiresAuth: true,permission:'VOICE_MAIL_LIST'},

                component: () => import( '../components/management/drafts/sms')
            },
            {
                path: 'field-management/:id?',
                meta: {requiresAuth: true , permission:'TASK_FORM_LIST'},
                name: 'FieldManagement',
                component: () => import('../components/management/formManage/Fields')
            },
            {
                path: 'field-management/add-role/:id/:ruleId?',
                meta: {requiresAuth: true , permission:'TASK_FORM_LIST'},
                name: 'AddRole',
                component: () => import('../components/management/formManage/AddRole')
            },
            {
                path: 'call-notifier',
                meta: {requiresAuth: true},
                name: 'CallNotifier',
                component: () => import('../components/management/CallNotifier')
            },
            {
                path: 'call-notifier-logs/:id?',
                meta: {requiresAuth: true},
                name: 'CallNotifierLogs',
                component: () => import('../components/management/CallNotifierLogs')
            },

            {
                path: 'contact-management',
                meta: {requiresAuth: true, permission:'CONTACT_LIST'},
                name: 'ContactComponent',
                component: () => import('../components/management/ContactComponent'),

            },
            {
                path: 'contact-management/history/:id',
                meta: {requiresAuth: true, permission:'CONTACT_LIST'},
                name: 'ContactHistory',
                component: () => import('../components/management/ContactHistory')
            },


            {
                path: 'reports',
                /*  meta: {requiresAuth: true},*/
                children: [
                    {
                        path: 'all-reports',
                        meta: {requiresAuth: true, permission:'TASK_FORM_LIST'},
                        name: 'ReportsComponent',
                        component: () => import('../components/management/reports/ReportsComponent')
                    },
                    {
                        path: 'expert-performance',
                        meta: {requiresAuth: true, permission:'TASK_FORM_LIST'},
                        name: 'ExpertPerformance',
                        component: () => import('../components/management/reports/ExpertPerformance')
                    },
                    {
                        path: 'expert-department',
                        meta: {requiresAuth: true, permission:'TASK_FORM_LIST'},
                        name: 'ExpertDepartment',
                        component: () => import('../components/management/reports/ExpertDepartment')
                    },
                    {
                        path: 'comparative',
                        meta: {requiresAuth: true, permission:'TASK_FORM_LIST'},
                        name: 'ComparativeComponent',
                        component: () => import('../components/management/reports/ComparativeComponent')
                    },
                    {
                        path: 'sla',
                        meta: {requiresAuth: true, permission:'TASK_FORM_LIST'},
                        name: 'SlaComponent',
                        component: () => import('../components/management/reports/SlaComponent')
                    },
                    {
                        path: 'poll-report',
                        meta: {requiresAuth: true, permission:'TASK_FORM_LIST'},
                        name: 'PollReport',
                        component: () => import('../components/management/reports/PollReport')
                    },
                    {
                        path: 'passenger-analysis',
                        name: 'PassengerAnalysis',
                        meta: {requiresAuth: true, permission:'TASK_FORM_LIST'},

                        component: () => import( '../components/management/reports/PassengerAnalysis')
                    },
                    {
                        path: 'customer-analysis',
                        name: 'CustomerAnalysis',
                        meta: {requiresAuth: true, permission:'TASK_FORM_LIST'},

                        component: () => import( '../components/management/reports/CustomerAnalysis')
                    },
                    {
                        path: 'call-monitor',
                        meta: {requiresAuth: true, permission:'TASK_FORM_LIST'},
                        name: 'CallMonitor',
                        component: () => import('../components/management/callMonitoring/CallMonitor')
                    },

                ]

            },

        ]
    },
    {
        path: '/auth',
        meta: {requiresAuth: false , withoutLayout: true},
        children: [
            {
                path: 'login',
                name: 'LoginComponent',
                component: Login,
            },
            {
                path: 'password',
                name: 'PasswordComponent',
                component: Password,
            }, {
                path: 'otp',
                component: Otp,
            }, {
                path: 'forget-password',
                component: forget,
            }, {
                path: 'choice-password',
                component: NewPassword,
            }, {
                path: 'check-login',
                name: 'CheckLogin',
                component: CheckLogin,
                meta: {requiresAuth: false},
            },

        ],
    },
    {
        path: '/error/error-503',
        name: 'Error503',
        component: Error503View,
        meta: {requiresAuth: false,withoutLayout: true},
    },
    {
        path: '/error/error-403',
        name: 'Error403',
        component: Error403View,
        meta: {requiresAuth: false,withoutLayout: true},
    },
    {
        path: '/error/error-401',
        name: 'Error401',
        component: () => import( '../views/Error401View.vue'),
        meta: {requiresAuth: false,withoutLayout: true},
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: Error404View,
        meta: {requiresAuth: false,withoutLayout: true},
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

let accessMenus = {
    portal: false,
    workflow_management: false,
    artificial_intelligence: false,
}
let features = []

import store from "@/store";
import { useUserStore } from '@/store/user'
router.beforeEach((to, from, next) => {
    const userStore = useUserStore()   // ← فقط داخل beforeEach
    if (userStore.userInfo) {
        let data = userStore.userInfo
        features = data?.data?.features

    }

    const updateSettings = () => {
        Object.keys(accessMenus).forEach((key) => {
            const featureName = key.replace(/^is/, '').toLowerCase();
            accessMenus[key] = features?.some((feature) => feature.name && feature.name.toLowerCase() === featureName);
        });
    };
    updateSettings();
    /*if (to.fullPath.includes('auth') || to.fullPath.includes('error')) {
        store.commit('setWithoutLayout', true)
    } else {
        store.commit('setWithoutLayout', false)
    }*/

    const nearestWithTitle = to.matched.find(r => r.meta?.title)
    document.title = nearestWithTitle ? nearestWithTitle.meta.title : 'اجیستنت'
    if (to.fullPath.includes('management')) {
        store.commit('setPanelRole', '0')
        localStorage.setItem('panel-role', '0')
    } else if (to.fullPath.includes('admin')) {
        store.commit('setPanelRole', '1')
        localStorage.setItem('panel-role', '1')
    }

    const isAuthenticated = !!localStorage.getItem('token')
    const requiresAuth = to.matched.some(r => r.meta?.requiresAuth === true)


    if (requiresAuth && !isAuthenticated) {
        return next('/auth/login')
    }

    if (!requiresAuth && isAuthenticated && to.fullPath.includes('/auth')) {
        return next('/')
    }

    /*const requiredFeatures = to.meta.requiredFeatures || []
    if (requiredFeatures.length) {
        const hasAccess = requiredFeatures.every(f => accessMenus[f])
        if (!hasAccess) {
            return next('/error/error-403')
        }
    }
     const userInfo = JSON.parse(localStorage.getItem('userInfo'))
     const userPermissions = computed(() => {
         return userInfo.data.permissions.flatMap(cat =>
             cat.permissions.map(p => p.name)
         )
     })

     if (to.meta.permission) {

         if (!userPermissions.value.includes(to.meta.permission)) {
             return next({ name: "Error403" })
         }

     }*/

    next()
})


export default router
